<template>
  <hr class="-mx-6 my-4 border-outline-variant" />
</template>
<script lang="ts" setup></script>
